var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tg-nyjdownload",on:{"click":_vm.openOrDownload}},[_c('img',{staticClass:"bapic",attrs:{"src":require("../../../assets/nyj/nyj_bg.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }